import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router';
import FeedbackAgentView from '@/views/FeedbackAgent/FeedbackAgentView.vue';
import InsightsView from '@/views/Insights/InsightsView.vue';

// Routes match each IComponent.FrontendRoute on the backend. Adding a new
// component means dropping a new view here.
const routes: RouteRecordRaw[] = [
  { path: '/documentai-feedback-agent', component: FeedbackAgentView },
  { path: '/insights', component: InsightsView },
  { path: '/:pathMatch(.*)*', redirect: '/documentai-feedback-agent' }
];

export const router = createRouter({
  history: createWebHistory(),
  routes
});
